import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Heading, Link } from '@hover/blueprint';
import { ISiteData } from '../../../interfaces/ISiteData';

const ContactUs: React.FC = () => {
  const {
    site: {
      siteMetadata: { contact },
    },
  } = useStaticQuery<ISiteData>(graphql`
    query GetContactQuery {
      site {
        siteMetadata {
          contact {
            email
            phone
          }
        }
      }
    }
  `);

  return (
    <>
      <Heading size={500} isLight marginBottom={200} as="h2">
        Have questions?
      </Heading>
      <Heading
        as="p"
        fontWeight={400}
        size={200}
        isLight
        marginBottom={{ base: 200, tablet: 400 }}
      >
        If you have questions about these terms or anything else about HOVER,
        contact us:
      </Heading>
      <Link href={`tel:${contact.phone}`} mb={200}>
        {contact.phone}
      </Link>
      <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
    </>
  );
};

export default ContactUs;
